import React from 'react';
import { Link } from 'react-router-dom';
import MediaItem from './MediaItem';

const MediaList = ({
  items = [],
  isLoading,
  mediaType, // 'anime' or 'manga'
  activeStatus,
  statusLabel,
  maxHeight = '700px' // Default max height for the scrollable area
}) => {

  const seeAllLink = mediaType === 'anime' 
    ? `/my-anime-list` 
    : `/my-manga-list`;

  return (
    <div className="favorites-card">
      <div className="favorites-header">
        <h3>
          {statusLabel || (mediaType === 'anime' ? 'Anime' : 'Manga')}
          {!isLoading && (
            <span className="item-count">{` (${items.length})`}</span>
          )}
        </h3>
        <Link to={seeAllLink} className="see-all-link">See All</Link>
      </div>
      
      <div className="favorites-list-container">
        {isLoading ? (
          <div className="favorites-loading">Loading your {mediaType} list...</div>
        ) : items.length === 0 ? (
          <div className="favorites-loading">
            No {mediaType} in your {statusLabel?.toLowerCase() || mediaType} list
          </div>
        ) : (
          <div className="favorites-list scrollable" style={{ maxHeight }}>
            {items.map((item, index) => (
              <MediaItem 
                key={item._id}
                item={item}
                mediaType={mediaType}
                status={activeStatus}
                // Add staggered animation delay
                style={{ animationDelay: `${0.05 * index}s` }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MediaList;